import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { SessionEventArgs } from "./Exports";
/**
 * Defines payload for session events like Speech Start/End Detected
 * @class
 */

export var RecognitionEventArgs = /*#__PURE__*/function (_SessionEventArgs) {
  _inherits(RecognitionEventArgs, _SessionEventArgs);

  var _super = _createSuper(RecognitionEventArgs);

  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} offset - The offset.
   * @param {string} sessionId - The session id.
   */
  function RecognitionEventArgs(offset, sessionId) {
    var _this;

    _classCallCheck(this, RecognitionEventArgs);

    _this = _super.call(this, sessionId);
    _this.privOffset = offset;
    return _this;
  }
  /**
   * Represents the message offset
   * @member RecognitionEventArgs.prototype.offset
   * @function
   * @public
   */


  _createClass(RecognitionEventArgs, [{
    key: "offset",
    get: function get() {
      return this.privOffset;
    }
  }]);

  return RecognitionEventArgs;
}(SessionEventArgs);